export const REPORTS_IDS = {
  COURSES_FINANCIAL_REPORT: 1,
  COURSES_GROUP_FINANCIAL_REPORT: 2,
  SURVEYS_COURSES: 3,
  SURVEYS_COURSE: 4,
  USER_REGISTRATIONS: 5,
  COURSE_REGISTRATIONS_BY_COURSE: 6,
  PLACE_COURSES: 7,
} as const;

export type ReportsIds = (typeof REPORTS_IDS)[keyof typeof REPORTS_IDS];

export const REPORTS_NAMES: Record<ReportsIds, string> = {
  [REPORTS_IDS.COURSES_FINANCIAL_REPORT]: "Zestawienie finansowe kursów",
  [REPORTS_IDS.COURSES_GROUP_FINANCIAL_REPORT]: "Zestawienie finansowe grupy kursów",
  [REPORTS_IDS.SURVEYS_COURSES]: "Raport porównawczy ocen kursów",
  [REPORTS_IDS.SURVEYS_COURSE]: "Raport ocen pojedynczego kursu",
  [REPORTS_IDS.USER_REGISTRATIONS]: "Rejestracja użytkowników w systemie",
  [REPORTS_IDS.COURSE_REGISTRATIONS_BY_COURSE]: "Rejestracja na kursy",
  [REPORTS_IDS.PLACE_COURSES]: "Zestawienie kursów odbywających się w miejscach",
} as const;
